import sanitizeAndExtractHtml, { SanitizeAndExtractHtmlResult } from "../../../utils/sanitize-and-extract-html";
import { MediaGet, MediaType, thor } from "../../../typings/thor";
import { Enums } from "../../../thor.enums";

export class UpsertMediaVideoDialogController {
    public static $inject: string[] = [
        "$element",
        "$mdDialog",
        "$mdMedia",
        "$rootScope",
        "$translate",
        "mediaService",
        "toaster",
        "utilsService",
        "media",
        "resource"
    ];

    private videoEmbedField: string;
    private $t;

    constructor(
        private $element: JQLite,
        private $mdDialog: ng.material.IDialogService,
        public $mdMedia: ng.material.IMedia,
        private $rootScope: ng.IRootScopeService,
        $translate: ng.translate.ITranslateService,
        private mediaService,
        private toaster,
        private utils,
        // binded from dialog locals
        public media: MediaGet,
        public resource: thor.ItemGet
    ) {
        this.$t = $translate.instant;
    }

    public $onInit() {
        this.videoEmbedField = this.media.meta?.video_embed;

        angular.element(() => {
            const tooltip = this.$element[0].querySelectorAll(".tooltiped");
            M.Tooltip.init(tooltip, {});
        });
    }

    public upsertMediaVideo() {
        const videoEmbeds = sanitizeAndExtractHtml(this.videoEmbedField);
        const body = {
            type: MediaType.ItemVideo,
            meta: { video_embed: null }
        };

        videoEmbeds.forEach((videoEmbed: SanitizeAndExtractHtmlResult | string) => {
            videoEmbed = this.utils.videoEmbedObjToString(videoEmbed);

            if (body.meta.video_embed || !videoEmbed) {
                return;
            }
            body.meta.video_embed = videoEmbed;
        });

        return this.mediaService
            .updateMedia(this.media.id, body)
            .then((res: MediaGet) => {
                const mediaIndex = this.resource.medias.findIndex(o => o.id === res.id);

                if (mediaIndex !== -1) {
                    this.resource.medias[mediaIndex] = res;
                }
                this.$rootScope.$broadcast(
                    `${(<any>this.$rootScope).eventPrefix || Enums.ContentTypes.Item}.updated`,
                    this.resource
                );
            })
            .catch(() => this.toaster.show(this.$t("une_erreur_est_survenue"), true))
            .finally(() => this.cancelDialog());
    }

    public cancelDialog() {
        this.$mdDialog.cancel();
    }
}
